var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPriceDown = function SvgPriceDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.402 3.969c-.116-.279.209-.54.458-.37C5.94 4.34 7.707 5.5 8.149 5.5c.43 0 1.991-1.105 2.989-1.846.244-.181.582.073.473.357L8.418 12.3a.3.3 0 0 1-.557.007z"
  })));
};
export { SvgPriceDown as ReactComponent };
export default __webpack_public_path__ + "26c25bc12c060727671bbd744a7c7d8a.svg";